var _excluded = ["actions", "children", "className", "color", "enableColorOnDark", "logo"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import clsx from 'clsx';
import { AppBar as MuiAppBar, Toolbar, Container, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Root = styled(MuiAppBar, {
  name: 'MnrlAppBar',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.root];
  }
})(function (_ref) {
  var _ref$ownerState = _ref.ownerState,
      color = _ref$ownerState.color,
      enableColorOnDark = _ref$ownerState.enableColorOnDark,
      theme = _ref.theme;
  return _extends({
    borderBottom: '1px solid transparent',
    // Always present so size does not change
    boxShadow: 'none',
    flexDirection: 'row'
  }, (!color || ['inherit', 'transparent'].includes(color) || theme.palette.mode === 'dark' && !enableColorOnDark) && {
    borderColor: theme.palette.divider // Make bottom border visible

  });
});
var StyledToolbar = styled(Toolbar, {
  name: 'MnrlAppBar',
  slot: 'Toolbar',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.toolbar];
  }
})(function (_ref2) {
  var _ref3;

  var theme = _ref2.theme;
  return _ref3 = {
    flexGrow: 1
  }, _ref3["" + theme.breakpoints.up('xs')] = {
    padding: 0
  }, _ref3;
});
var StyledContainer = styled(Container, {
  name: 'MnrlAppBar',
  slot: 'Container',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.container];
  }
})(function (_ref4) {
  var _ref5;

  var theme = _ref4.theme;
  return _ref5 = {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    maxWidth: 'inherit'
  }, _ref5["" + theme.breakpoints.up('xs')] = {
    paddingLeft: parseInt(theme.sizing.drawerGutter) - parseInt(theme.spacing(1)) / 2 + "px"
  }, _ref5;
});
var LogoType = styled('div', {
  name: 'MnrlAppBar',
  slot: 'LogoType',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.logoType];
  }
})({
  alignItems: 'center',
  display: 'flex'
});
var Actions = styled('div', {
  name: 'MnrlAppBar',
  slot: 'Actions',
  overridesResolver: function overridesResolver(props, styles) {
    return [styles.actions];
  }
})(function (_ref6) {
  var theme = _ref6.theme;
  return {
    alignItems: 'center',
    display: 'flex',
    '&& > *': {
      marginLeft: theme.spacing(2)
    }
  };
});
export var AppBar = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var actions = _ref7.actions,
      children = _ref7.children,
      className = _ref7.className,
      _ref7$color = _ref7.color,
      color = _ref7$color === void 0 ? 'primary' : _ref7$color,
      enableColorOnDark = _ref7.enableColorOnDark,
      logo = _ref7.logo,
      restProps = _objectWithoutPropertiesLoose(_ref7, _excluded);

  return /*#__PURE__*/_jsx(Root, _extends({
    className: clsx('MnrlAppBar-root', className),
    color: color,
    enableColorOnDark: enableColorOnDark,
    ownerState: {
      color: color,
      enableColorOnDark: enableColorOnDark
    }
  }, restProps, {
    ref: ref,
    children: /*#__PURE__*/_jsx(StyledToolbar, {
      className: "MnrlAppBar-toolbar",
      children: /*#__PURE__*/_jsxs(StyledContainer, {
        maxWidth: false,
        className: "MnrlAppBar-container",
        children: [logo && /*#__PURE__*/_jsx(LogoType, {
          className: "MnrlAppBar-logoType",
          children: logo
        }), children, actions && /*#__PURE__*/_jsx(Actions, {
          className: "MnrlAppBar-actions",
          children: actions
        })]
      })
    })
  }));
});